const NEXT_STEP_BUTTON_TEXT = {
  continue: 'UpdateApplication.Continue',
  start: 'UpdateApplication.Start',
  nextStep: 'UpdateApplication.NextStep',
};

type getButtonTextProps = {
  isFirstStep: boolean;
  hasFinishedSteps: boolean;
};
export const getNextStepButtonText = ({
  isFirstStep,
  hasFinishedSteps,
}: getButtonTextProps) => {
  if (isFirstStep) {
    if (hasFinishedSteps) {
      return NEXT_STEP_BUTTON_TEXT.continue;
    }
    return NEXT_STEP_BUTTON_TEXT.start;
  }
  return NEXT_STEP_BUTTON_TEXT.nextStep;
};
